import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
export default function extendDiscussionComposer() {
  extend('flarum/forum/components/DiscussionComposer', 'headerItems', function (items) {
    const tags = this.composer.fields.tags;
    if (tags === undefined) return;
    const qna = tags.some(t => t.isQnA());
    if (!qna) return;
    this.attrs.titlePlaceholder = app.translator.trans('fof-best-answer.forum.composer.titlePlaceholder');
    if (items.has('discussionTitle')) {
      items.setContent('discussionTitle', m("h3", null, m("input", {
        className: "FormControl",
        bidi: this.title,
        placeholder: this.attrs.titlePlaceholder,
        disabled: !!this.attrs.disabled,
        onkeydown: this.onkeydown.bind(this)
      })));
    }
  });
}
flarum.reg.add('fof-best-answer', 'forum/extenders/extendDiscussionComposer', extendDiscussionComposer);